import { all, call, fork, put, select, take } from 'redux-saga/effects';

import { securityAccountSelectedSelector } from '!core/redux/userSecuritiesAccounts/userSecuritiesAccounts.selectors';
import { handleSagaError } from '»utils/handleSagasError';

import { publicOfferServices } from './publicOffer.services';
import { publicOfferSlice } from './publicOffer.slice';

const publicOfferDailyWorker = function* () {
  try {
    const securityAccount = yield select(securityAccountSelectedSelector);

    const publicOfferData = yield call(publicOfferServices.publicOffer, {
      account: securityAccount,
    });

    yield put(publicOfferSlice.actions.publicOfferDailySucess(publicOfferData));
  } catch (error) {
    const handled = yield call(handleSagaError, error);
    if (!handled) yield put(publicOfferSlice.actions.publicOfferDailyFailure());
  }
};

const publicOfferDailySagas = function* () {
  while (true) {
    const authorized = false;
    try {
      while (!authorized) {
        yield take(publicOfferSlice.actions.publicOfferDailyRequest.type);
        yield call(publicOfferDailyWorker);
      }
    } catch {
      yield put(publicOfferSlice.actions.publicOfferDailyFailure());
    }
  }
};

const publicOfferHstWorker = function* () {
  try {
    const securityAccount = yield select(securityAccountSelectedSelector);

    const publicOfferHstData = yield call(
      publicOfferServices.publicOfferHistorical,
      {
        account: securityAccount,
      },
    );

    yield put(
      publicOfferSlice.actions.publicOfferHstSucess(publicOfferHstData),
    );
  } catch (error) {
    const handled = yield call(handleSagaError, error);
    if (!handled) yield put(publicOfferSlice.actions.publicOfferHstFailure());
  }
};

const publicOfferHstSagas = function* () {
  while (true) {
    const authorized = false;
    try {
      while (!authorized) {
        yield take(publicOfferSlice.actions.publicOfferHstRequest.type);
        yield call(publicOfferHstWorker);
      }
    } catch {
      yield put(publicOfferSlice.actions.publicOfferHstFailure());
    }
  }
};

export const publicOfferSagas = function* () {
  try {
    yield all([fork(publicOfferDailySagas), fork(publicOfferHstSagas)]);
  } catch {}
};
